export const changeLanguage = language => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: "CHANGE_LANGUAGE", language })
        resolve()
    })
